module.exports = __webpack_public_path__ + "static/media/tecnologia.1c306ce4.svg";